var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabNavRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "tabNavRight",
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_645_955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_645_955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3 28L23.1667 21.8667L25.0333 20L33.0333 28L25.0333 36L23.1667 34.1333L29.3 28Z",
    fill: "#49247D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabNavRight);
export default __webpack_public_path__ + "static/media/TabNavRight.15e3e9a9ba2122dab7540940706323a1.svg";
export { ForwardRef as ReactComponent };